<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  modal-trocar-responsavel(
    v-if="showModalResponsavel",
    :processo="processoTrocado",
    @closeModal="FECHAR_MODAL_RESPONSAVEL"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="infoPrazos",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import AppListagem from '@/components/AppListagem'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_PORTARIA_EMISSAO'),
      items: [],
      totalElements: 0,
      infoPrazos: undefined,
      processosSelecionados: [],
      showModalResponsavel: false,
      processoTrocado: null,
      numeroProcesso: null,
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      idsProcessosAssinatura: [],
      showModalAssinatura: false,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_PORTARIA_EMISSAO || [],
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_PORTARIA_EMISSAO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Situação', propriedade: 'status', ordem: 4, acoes: [], exibir: () => this.showColuna('filtroSituacao') },
        { id: 4, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 5, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 6, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => this.showColuna('filtroResponsavel') },
        { id: 7, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 5, acoes: [], isPrazo: true, exibir: () => true },
        {
          id: 8, titulo: 'Ações', propriedade: 'tipo', ordem: 6, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Continuar Emissão de Portaria', icone: 'fa-edit', codigo: 'EMITIR_PORTARIA', ordem: 1, show: this.showContinuarEmissaoPortaria },
            { id: 2, nome: 'Revisar Portaria', icone: 'fa-check', codigo: 'EMITIR_PORTARIA', ordem: 2, show: this.showRevisarPortaria },
            { id: 3, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_RESPONSAVEL', ordem: 1, show: this.showTrocarResponsavel }

          ]
        }
      ],
      filtroRapido: null
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    })
  },

  methods: {
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario.perfilSelecionado.codigo) !== undefined
    },
    EMITIR_PORTARIA: async (_this, { item }) => {
      _this.$router.push({
        name: 'portaria',
        params: {
          idProcesso: item.id,
          protocolo: item.numeroProtocolo
        }
      })
    },

    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    TROCAR_RESPONSAVEL: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },

    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },

    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },

    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEmEmissaoPortaria.vue